import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

const SimpleField = (props) => {

	return (
		<div className={cx('SimpleField', 'form-group', props.wrapperClass)}>
			<label htmlFor={props.id} className={props.labelClassName}>{props.label}</label>
			{ props.secondaryLabel && <div className="small text-secondary">{props.secondaryLabel}</div> }
				<input value={props.value}
					name={props.name}
					onChange={props.onChange}
					onBlur={props.onBlur}
					type={props.type}
					className={cx('form-control', props.className, {'is-invalid': props.touched && props.errorMessage})}
					id={props.id}
					readOnly={props.readOnly === true ? true : undefined}
					maxLength={props.maxLength}
				/>
			{ props.touched && props.errorMessage &&
					<div className="validationError invalid-feedback">
						{props.validationIconClass && <span className={props.validationIconClass}></span>}
						<span className="validationErrorMessage" id={`${props.id}-errorMessage`}>{props.errorMessage}</span>
					</div>
				}
		</div>
	);
};

SimpleField.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	touched: PropTypes.bool.isRequired,
	wrapperClass: PropTypes.string,
	errorMessage: PropTypes.string,
	id: PropTypes.string,
	name: PropTypes.string,
	className: PropTypes.string,
	type: PropTypes.string,
	readOnly: PropTypes.bool,
	maxLength: PropTypes.number,
	label: PropTypes.string,
	labelClassName: PropTypes.string,
	secondaryLabel: PropTypes.string,
	validationIconClass: PropTypes.string,
	onBlur: PropTypes.func
};

export default SimpleField;
